import { setWindowLocation } from '@eventbrite/http';

export const handleRedirect = (url) => () => setWindowLocation(url);
